import 'zone.js';
import { platformBrowser } from '@angular/platform-browser';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppModule } from './app/app-module';


platformBrowser()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

//   import 'zone.js';
// import { platformBrowser } from '@angular/platform-browser';
// import { bootstrapApplication } from '@angular/platform-browser';
// import { AppModule } from './app/app-module';
// import { AppComponent } from './app/app';
// import { provideHttpClient } from '@angular/common/http';
// import { provideRouter } from '@angular/router';
// import { routes } from './app/app-routing-module';

// bootstrapApplication(AppComponent, {
//   providers: [
//     provideHttpClient(),  // ✅ this line is required
//     provideRouter(routes)
//   ]
// });
// platformBrowser()
//   .bootstrapModule(AppModule)
//   .catch(err => console.error(err));

